<div class="distributers-container">
  <div class="header-style">
    <div class="total-number">
      <p><span i18n="@@totalDistributors">Total Number Of Distributors: </span>{{totalSize}}</p>
    </div>
    <div class="d-flex justify-content-center align-items-center">
      <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageIndex]="pageNumber - 1" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handlePage($event)"></mat-paginator>
      
      @if (distributorsList.length > 0) {
        <mat-menu #exportMenu="matMenu">
          <button mat-menu-item i18n="@@exportAsCSV" (click)="exportDistributors(1)">Export as CSV</button>
          <button mat-menu-item i18n="@@exportAsPDF" (click)="exportDistributors(2)">Export as PDF</button>
          <button mat-menu-item i18n="@@exportAsExcel" (click)="exportDistributors(3)">Export as Excel</button>
        </mat-menu>
        <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" [matMenuTriggerFor]="exportMenu" i18n-aria-label aria-label="@@export"></mat-icon>
      }
        
      <form [formGroup]="searchForm" (ngSubmit)="doSearch()">
        @if (showSearch) {
          <mat-form-field class="search-field">
            <mat-label i18n="@@searchLabel">Search</mat-label>
            <input i18n-placeholder="@@searchPlaceholder" data-testid="distributors_search_input" matInput formControlName="search" id="search" placeholder="Search" name="search"/>
            <mat-icon class="cursor search-icon" data-testid="distributors_clear_button" matSuffix (click)="clearSearch()" i18n-aria-label aria-label="@@clear">clear</mat-icon>
          </mat-form-field>
        }
      </form>
      <mat-icon data-testid="distributors_search_button" (click)="handleSearchClick()" class="cursor" svgIcon="search" aria-hidden="false" i18n-aria-label aria-label="@@search"></mat-icon>
    </div>
  </div>

  @for (item of distributorsList; track item; let itemIndex = $index) {
    <mat-card class="{{(itemIndex % 2 === 0 ? 'details-box mr-16 ' : 'details-box')}}">
      <mat-card-content class="d-flex">
        <img class="cursor" (click)="goToDistributor(item.businessName, item.id)" [src]="item.picturePath" (error)="onImgError($event)" i18n-alt alt="Distributor image">
        <div class="content-box">
          <div class="cursor w-90" (click)="goToDistributor(item.businessName, item.id)">
            @if (item.firstName) {
              <div class="mat-subtitle-1 margin-bottom" matTooltip ellipsisTooltip>
                {{item.firstName + ' ' + item.lastName}} @if (utils.getUserStatus(item.status) === 'banned') {<span i18n="@@baned">(Baned)</span>}
              </div>
            }
            @if (!item.firstName) {
              <div class="mat-subtitle-1 margin-bottom" matTooltip ellipsisTooltip>
                {{item.businessName}}<span i18n="@@owner"> Owner</span>  @if (utils.getUserStatus(item.status) === 'banned') {<span i18n="@@baned"> (Baned)</span>}
              </div>
            }
            <div class="mat-caption margin-bottom" matTooltip ellipsisTooltip>{{item.businessName}}</div>
            <div class="mat-caption margin-bottom" matTooltip ellipsisTooltip>{{item.phone ? '+' : ''}}{{item.countryCode}}{{item.phone}}</div>
            <div class="mat-caption margin-bottom" matTooltip ellipsisTooltip>{{item.registrationDate}}</div>
            <div class="mat-caption" matTooltip ellipsisTooltip>>
              <span i18n="@@plan">Plan:</span>
              {{ utils.planNameByCount(item.promotionCodeCount,"distrebuter")}}
            </div>
          </div>
          <div class="d-flex">
            <mat-icon class="cursor vertical-icon" [matMenuTriggerFor]="menu" color="accent" i18n-aria-label aria-label="@@moreOptions">more_vert</mat-icon>
          </div>
          <mat-menu #menu="matMenu">
            @if (utils.getUserStatus(item.status) === 'banned') {
              <button i18n="@@unban" data-testid="unban_button" (click)="unblock(item.id)" mat-menu-item>Unban</button>
            }
            @if (utils.getUserStatus(item.status) === 'active') {
              <button i18n="@@ban" data-testid="ban_button" (click)="block(item.id)" mat-menu-item>Ban</button>
            }
          </mat-menu>
        </div>
      </mat-card-content>
    </mat-card>
  }

  @if (distributorsList.length === 0) {
    <img class="empty-view-img" i18n-alt alt="No data" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
  }
</div>
